import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Campus from './components/campus/Campus';
import SubscriptionPanel from './components/suscripcion/SubscriptionPanel';
import PortalSelection from './components/PortalSelection';
import NoAccess from './components/NoAccess';
import AdminDashboard from './components/admin/AdminDashboard';
import Login from './components/Login';
import Unsubscribe from './components/Unsubscribe';
import CoursePlayer from './components/campus/CoursePlayer';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center bg-slate-50">Cargando...</div>;
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

const CampusRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center bg-slate-50">Cargando...</div>;
    }

    if (!user) {
        console.log("user")
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user.role === 'Admin') return children;

    if (!user.campusEnabled) {
        if (user.subscriptionEnabled) {
            return <Navigate to="/suscripcion" replace />;
        }
        return <Navigate to="/no-access" replace />;
    }

    return children;
};

const SubscriptionRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center bg-slate-50">Cargando...</div>;
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user.role === 'Admin') return children;

    if (!user.subscriptionEnabled) {
        if (user.campusEnabled) {
            return <Navigate to="/campus" replace />;
        }
        return <Navigate to="/no-access" replace />;
    }

    return children;
};

const AdminRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center bg-slate-50">Cargando...</div>;
    }

    if (!user || user.role !== 'Admin') {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default function App() {
    return (
        <AuthProvider>
            <Router>
                <ScrollToTop />
                <div className="font-sans text-slate-700 bg-slate-50 scroll-smooth">
                    <Routes>
                        <Route path="/" element={<Navigate to="/login" replace />} />
                        <Route path="/login" element={<Login />} />
                        <Route 
                            path="/portal-selection" 
                            element={
                                <ProtectedRoute>
                                    <PortalSelection />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/campus" 
                            element={
                                <CampusRoute>
                                    <Campus />
                                </CampusRoute>
                            } 
                        />
                        <Route
                            path="/campus/course/:courseId"
                            element={
                                <CampusRoute>
                                    <CoursePlayer />
                                </CampusRoute>
                            }
                        />
                        <Route 
                            path="/suscripcion" 
                            element={
                                <SubscriptionRoute>
                                    <SubscriptionPanel />
                                </SubscriptionRoute>
                            } 
                        />
                        <Route 
                            path="/no-access" 
                            element={
                                <ProtectedRoute>
                                    <NoAccess />
                                </ProtectedRoute>
                            } 
                        />
                        <Route 
                            path="/admin" 
                            element={
                                <AdminRoute>
                                    <AdminDashboard />
                                </AdminRoute>
                            } 
                        />
                        <Route path="/unsubscribe" element={<Unsubscribe />} />
                        {/* Catch all - redirect to login */}
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </div>
            </Router>
        </AuthProvider>
    );
}
